"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkbox_group = _interopRequireDefault(require("./checkbox_group"));

var _checkbox_states = _interopRequireDefault(require("./utils/checkbox_states"));

require("../css/treeview.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var itemsPropType = _propTypes.default.arrayOf(_propTypes.default.shape({
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  totalItems: _propTypes.default.number,
  value: _propTypes.default.node.isRequired,
  isExpanded: _propTypes.default.bool
}));

var TreeView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TreeView, _React$Component);

  _createClass(TreeView, null, [{
    key: "changeCheckedState",
    value: function changeCheckedState(currentCheck, newCheck) {
      if (currentCheck === undefined) {
        if (newCheck !== undefined) {
          return newCheck;
        }

        return _checkbox_states.default.unchecked;
      }

      if (currentCheck === newCheck) {
        return currentCheck;
      }

      return _checkbox_states.default.indeterminated;
    }
  }]);

  function TreeView(props) {
    var _this;

    _classCallCheck(this, TreeView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeView).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (items) {
      var newItems = items.map(function (item) {
        return _this.recursive(item);
      });

      _this.setState({
        items: newItems
      });

      _this.props.onChange(newItems);
    });

    _this.state = {
      items: props.items.map(function (item) {
        return _this.recursive(item);
      })
    };
    return _this;
  }

  _createClass(TreeView, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.items !== nextProps.items) {
        var newItems = nextProps.items.map(function (item) {
          return _this2.recursive(item);
        });
        this.setState({
          items: newItems
        });
      }
    }
  }, {
    key: "recursive",
    value: function recursive(item) {
      var _this3 = this;

      var newItem = item;

      if (newItem.items == null) {
        if (newItem.checked === undefined) {
          newItem.checked = _checkbox_states.default.unchecked;
        } else {
          newItem.checked = _checkbox_states.default[newItem.checked];
        }

        return newItem;
      }

      var checked;
      newItem.items = item.items.map(function (child) {
        var newChild = child;

        if (_checkbox_states.default[newItem.checked] === _checkbox_states.default.checked) {
          newChild.checked = _checkbox_states.default.checked;
        } else if (_checkbox_states.default[newItem.checked] === _checkbox_states.default.unchecked) {
          newChild.checked = _checkbox_states.default.unchecked;
        }

        newChild = _this3.recursive(newChild);
        checked = TreeView.changeCheckedState(checked, newChild.checked);
        return newChild;
      });
      newItem.checked = checked;
      return newItem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          maxHeight = _this$props.maxHeight,
          onChange = _this$props.onChange,
          title = _this$props.title,
          hideEmpty = _this$props.hideEmpty,
          items = _this$props.items,
          otherProps = _objectWithoutProperties(_this$props, ["maxHeight", "onChange", "title", "hideEmpty", "items"]);

      return _react.default.createElement("div", _extends({
        className: "vn-treeview"
      }, otherProps), title != null && _react.default.createElement("div", {
        className: "vn-treeview__header"
      }, _react.default.createElement("div", {
        className: "vn-treeview__inner-header"
      }, _react.default.createElement("span", {
        className: "vn-treeview__title"
      }, title))), _react.default.createElement(_checkbox_group.default, {
        items: this.state.items,
        maxHeight: maxHeight,
        onChange: this.handleChange,
        title: title,
        hideEmpty: hideEmpty
      }));
    }
  }]);

  return TreeView;
}(_react.default.Component);

TreeView.propTypes = {
  hideEmpty: _propTypes.default.bool,
  items: itemsPropType.isRequired,
  maxHeight: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  title: _propTypes.default.string
};
TreeView.defaultProps = {
  hideEmpty: false,
  maxHeight: '',
  title: ''
};
TreeView.displayName = 'TreeView';
var _default = TreeView;
exports.default = _default;